module.exports = __webpack_public_path__ + "static/media/manageAccess.00334d4d.png";